import { SocialIcon } from 'react-social-icons';

const Footer = () => {
   return (
      <footer className="bg-[#020066] text-white py-10 dark:bg-neutral-900" aria-labelledby="footer-title">
         <div className="container mx-auto text-center">
            <h1 id="footer-title" className="text-3xl font-bold">Full Stack Developer</h1>
            <p className="mt-2">Offering freelance remote custom website design services tailored to your needs</p>
            <nav className="mt-4 space-x-4" aria-label="Social Media Links">
               <SocialIcon 
                  url="https://github.com/Nitesh511" 
                  network="github" 
                  style={{ height: 40, width: 40 }} 
                  aria-label="GitHub Profile"
               />
               <SocialIcon
                  url="https://linkedin.com/in/Nitesh511"
                  network="linkedin"
                  style={{ height: 40, width: 40, marginRight: '10px' }}
                  aria-label="LinkedIn Profile"
               />
            </nav>
            <div className="mt-4 text-sm">
               <p>Copyright © 2024 Nitesh</p>
            </div>
         </div>
      </footer>
   );
};

export default Footer;
